<div class="container">
    <div class="button-menu-container">
        <button class="button-menu-first">
            <ng-content></ng-content>
        </button>
        <button class="button-menu-down-arrow" (click)="toggleMenu($event)">
            <span class="show-for-sr">Show Menu</span>&#9662;
        </button>
    </div>
    <div class="dropdown-items-container" [@height]="active ? 'opened' : 'closed'">
        <ng-content select="dropdown-select-item">
        </ng-content>
    </div>
</div>

